import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTheme } from '../ThemeProvider/useTheme';
import { hexToRGB } from '../../utils/colorConverter';
const BORDER_WIDTH = 0.03;
const StyledSvg = styled.svg `
  position: absolute;
  top: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  & .outer_border {
    transform: ${`scale(${1 + BORDER_WIDTH})`};
    transform-origin: center;
  }
  & .inner_border {
    transform: ${`scale(${1 - BORDER_WIDTH})`};
    transform-origin: center;
  }
  & .highlight_border {
    transform: scale(1.13);
    transform-origin: center;
  }
`;
export const SuperEllipseSvg = ({ image, withStroke, backgroundColor, strokeColor, highlight, }) => {
    const [randomIndex, setRandomIndex] = useState(0);
    const theme = useTheme();
    useEffect(() => {
        setRandomIndex(Math.random() * 1000);
    }, []);
    return (React.createElement(StyledSvg, { width: "1", height: "1", viewBox: "0 0 1 1", fill: backgroundColor },
        image && (React.createElement("defs", null,
            React.createElement("pattern", { id: `imgpattern${randomIndex}`, x: "0", y: "0", width: "100%", height: "100%" },
                React.createElement("image", { width: "100%", height: "100%", preserveAspectRatio: "xMidYMid slice", href: image })))),
        React.createElement("path", { d: "M0.5 0C0.15 0 0 0.15 0 0.5C0 0.85 0.15 1 0.5 1C0.85 1 1 0.85 1 0.5C1 0.15 0.85 0 0.5 0Z", fill: image ? `url(#${'imgpattern' + randomIndex})` : 'inherit' }),
        image && (React.createElement("path", { className: "inner_border", d: "M0.5 0C0.15 0 0 0.15 0 0.5C0 0.85 0.15 1 0.5 1C0.85 1 1 0.85 1 0.5C1 0.15 0.85 0 0.5 0Z", stroke: hexToRGB('#000000', 0.06), strokeWidth: `${BORDER_WIDTH}px`, fill: "transparent" })),
        withStroke && (React.createElement("path", { className: "outer_border", d: "M0.5 0C0.15 0 0 0.15 0 0.5C0 0.85 0.15 1 0.5 1C0.85 1 1 0.85 1 0.5C1 0.15 0.85 0 0.5 0Z", stroke: strokeColor || theme.colors.background.default, strokeWidth: `${BORDER_WIDTH}px`, fill: "transparent" })),
        highlight && (React.createElement("path", { className: "highlight_border", d: "M0.5 0C0.15 0 0 0.15 0 0.5C0 0.85 0.15 1 0.5 1C0.85 1 1 0.85 1 0.5C1 0.15 0.85 0 0.5 0Z", stroke: theme.colors.interactive.primary.default, strokeWidth: `${BORDER_WIDTH}px`, fill: "transparent" }))));
};
